<template>
  <div class="panel granary-panel">
    <div class="content">
      <div class="znj-box flex">
        <div class="jxh-item zzy-item" v-for="(item, i) in spList" :key="i">
          <p class="num">{{ item.num }}</p>
          <p class="fl-name">
            {{ item.name }}
            <span v-if="item.unit">({{ item.unit }})</span>
          </p>
        </div>
      </div>
      <div class="nyjx-box flex">
        <div class="jxh-item znj-item" v-for="(item, i) in mjList" :key="i">
          <p class="num">{{ item.num }}</p>
          <p class="fl-name">{{ item.name }}</p>
          <p v-if="item.unit">({{ item.unit }})</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDpDataItemByCode } from "@/api/granary";
export default {
  data() {
    return {
      spList: [
        {
          name: "涉农镇街数",
          num: 86,
          unit: "个"
        },
        {
          name: "乡镇户数",
          num: 138.3,
          unit: "万户"
        },
        {
          name: "乡镇人口",
          num: 575.21,
          unit: "万人"
        },
        {
          name: "乡镇就业人员",
          num: 268.79,
          unit: "万人"
        },
        {
          name: "集体资产总额",
          num: 6.9,
          unit: "亿元"
        },
        {
          name: "城乡居民收入差距",
          num: "2.59:1",
          unit: ""
        }
      ],
      mjList: [
        {
          name: "年生猪出栏量",
          num: 521.8471,
          unit: "万头"
        },
        {
          name: "年肉类产品产量",
          num: 70.1442,
          unit: "万吨"
        },
        {
          name: "年饲料产量",
          num: 220.1054,
          unit: "万吨"
        },
        {
          name: "生猪年末存栏数",
          num: 35.25,
          unit: "万头"
        },
        {
          name: "水产品总产值",
          num: 1032333,
          unit: "万元"
        },
        {
          name: "水产品总产量",
          num: 922169,
          unit: "吨"
        },
        {
          name: "水产养殖面积",
          num: 37497.82,
          unit: "公顷"
        },
        {
          name: "渔业船舶吨位",
          num: 125998,
          unit: "吨"
        },
        {
          name: "耕地面积",
          num: 226.68,
          unit: "千公顷"
        },
        {
          name: "农机总动力",
          num: 208.19,
          unit: "万千瓦"
        },
        {
          name: "农机作业总面积",
          num: 1040.6,
          unit: "千公顷"
        }
      ]
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      getDpDataItemByCode({ pagePanelCode: "sznc" }).then(res => {
        if (res && res.length > 0) {
          let spList = res.splice(0, 6);
          let mjList = res;
          this.spList = spList.map(ele => {
            return {
              name: ele.item_name,
              num: ele.value,
              unit: ele.unit
            };
          });
          this.mjList = mjList.map(ele => {
            return {
              name: ele.item_name,
              num: ele.value,
              unit: ele.unit
            };
          });
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.panel
    height 100%
    width 100%
.content
  width 100%
  height 100%
  padding 10px 10px 0 10px
  box-sizing border-box
.jxh-item
    width calc((100% - 30px) / 3)
    height calc((100% - 30px) / 2)
    // height 90px
    padding 10px 0 0 10px
    margin 0px 10px 0px 0
    box-sizing border-box
    background url("~images/granary/zzy/pecente2.png") no-repeat center
    background-size 100% 100%
    .num
      color #00ffff
      font-size 24px
    .fl-name
      color #fff
      font-size 14px
      margin-top 4px
  .zzy-item:nth-of-type(3n)
    margin-right 0
  .znj-item
    width calc((100% - 40px) / 4)
    height calc((100% - 40px) / 3)
    margin 0px 10px 0px 0
    &:nth-of-type(4n)
      margin-right 0
  .nyjx-box
    flex-wrap wrap
    height 60%
  .znj-box
    flex-wrap wrap
    height 40%
    .jxh-item
        // width 100%
        background url("~images/granary/zzy/percent-bg.png") no-repeat center
        background-size 100% 100%
        .num
          font-size 24px
          color #ff9f00
</style>
